export default "__VITE_ASSET__d35USxM$__"